import { last } from 'lodash';

import { SemboDate } from '@libs/sembo-dates';
import type { ChronologicalItinerary } from '@libs/trip-planner-interfaces';
import { getLongDatePeriod } from '@libs/utils';

export function getTravelDateRange(
  chronologicalItinerary: ChronologicalItinerary[]
): string {
  const firstDayTrip = chronologicalItinerary[0];
  const lastDayTrip = last(chronologicalItinerary);

  if (firstDayTrip && lastDayTrip) {
    const endDate = new SemboDate(lastDayTrip.startDate)
      .add({ days: lastDayTrip.numberOfNights })
      .get();
    return getLongDatePeriod(firstDayTrip.startDate, endDate);
  }

  return '';
}
